var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmoji(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.001,
    viewBox: "0 0 20.001 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon emoji"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .001)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.898 -75.501)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1196",
    d: "M25.9 95.5a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    "data-name": "\\uD0C0\\uC6D0 416",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(21.898 81.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    "data-name": "\\uD0C0\\uC6D0 417",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(27.898 81.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1197",
    d: "M26.274 91.5c-.094 0-.187 0-.282-.007a6.054 6.054 0 0 1-6.066-4.784 1 1 0 0 1 1.956-.42A4.056 4.056 0 0 0 26 89.5a3.712 3.712 0 0 0 3.91-3.143 1 1 0 0 1 1.978.292 5.666 5.666 0 0 1-5.614 4.851z",
    transform: "translate(-.006)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmoji);
export default __webpack_public_path__ + "static/media/icon-emoji.a811e7df02a8b30bc4a9a8d52bc2c98a.svg";
export { ForwardRef as ReactComponent };